type Tone = 'success' | 'danger' | 'warning' | 'primary' | 'info' | 'secondary';

const map: Record<Tone, string> = {
  success: 'badge-pk-success',
  danger: 'badge-pk-danger',
  warning: 'badge-pk-warning',
  primary: 'badge-pk-primary',
  info: 'badge-pk-info',
  secondary: 'badge-pk-secondary',
};

export function StatusBadge({
  tone = 'secondary',
  children,
}: {
  tone?: Tone;
  children: React.ReactNode;
}) {
  return <span className={`badge-pk ${map[tone]}`}>{children}</span>;
}

export function statusToneFromEnum(status: string): Tone {
  const s = status.toUpperCase();
  if (['ACTIVE', 'AVAILABLE', 'PAID', 'OPEN', 'CONFIRMED', 'COMPLETED', 'READY', 'OK'].includes(s)) {
    return 'success';
  }
  if (['OCCUPIED', 'PENDING', 'DRAFT', 'IN_PROGRESS', 'WARNING'].includes(s)) {
    return 'warning';
  }
  if (['CANCELLED', 'VOID', 'FAILED', 'ERROR', 'INACTIVE', 'CLOSED', 'REJECTED'].includes(s)) {
    return 'danger';
  }
  if (['RESERVED', 'SCHEDULED'].includes(s)) return 'info';
  return 'secondary';
}
